<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar sede" : "Nueva sede" }}
      </h1>
    </div>

    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>{{ editing ? "Datos de la sede" : "Datos de la nueva sede" }}</h3>
          </b-card-header>

          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0">
              <div class="row">

                <!-- Empresa -->
                <div class="col-md-8">
                  <div class="form-group">
                    <label>Empresa <span class="text-danger">*</span></label>
                    <SearchableDropdown
                      :options="companies"
                      :oldValue="form.companyId"
                      placeholder="Seleccione empresa"
                      :disabled="editing"
                      @selected="form.companyId = $event"
                    />
                    <FormError
                      v-if="$v.form.companyId.$error && !$v.form.companyId.required"
                      message="La empresa es requerida"
                    />
                  </div>
                </div>

                <!-- Código -->
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="code">Código</label>
                    <input
                      id="code"
                      type="text"
                      v-model="form.code"
                      autocomplete="off"
                      placeholder="Ej: SEDE01"
                      class="custom-form-control"
                    />
                  </div>
                </div>

                <!-- Nombre -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Nombre <span class="text-danger">*</span></label>
                    <input
                      id="name"
                      type="text"
                      v-model="form.name"
                      autocomplete="off"
                      placeholder="Nombre de la sede"
                      class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.name.$error }"
                    />
                    <FormError
                      v-if="$v.form.name.$error && !$v.form.name.required"
                      message="El nombre es requerido"
                    />
                  </div>
                </div>

                <!-- Dirección -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="address">Dirección</label>
                    <textarea
                      id="address"
                      v-model="form.address"
                      placeholder="Dirección de la sede"
                      class="custom-form-control"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'work-site-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">Guardar</button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError, SearchableDropdown } from "wize-admin";
import { required } from "vuelidate/lib/validators";
import { WorkSiteService, CompanyService } from "@/core/services";

export default {
  components: { FormError, SearchableDropdown },

  data() {
    return {
      editing:   false,
      companies: [],
      form: {
        companyId: null,
        name:      null,
        code:      null,
        address:   null,
      },
    };
  },

  validations: {
    form: {
      companyId: { required },
      name:      { required },
    },
  },

  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },

  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          companyId: this.form.companyId,
          name:      this.form.name,
          code:      this.form.code || null,
          address:   this.form.address || null,
        };

        let response;
        if (!this.editing) response = await WorkSiteService.save(data);
        else response = await WorkSiteService.update(this.$route.params.id, data);

        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name:   "work-site-edit",
            params: { id: response.payload.id },
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : "Error al guardar");
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },

    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const payload = (await WorkSiteService.get(id)).payload;
        this.form = {
          companyId: payload.company ? payload.company.id : null,
          name:      payload.name,
          code:      payload.code,
          address:   payload.address,
        };
        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar la sede");
        this.$router.push({ name: "work-site-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },

  async created() {
    const resp = await CompanyService.listAll();
    this.companies = (resp.payload || []).map((c) => ({ key: c.id, label: c.name }));
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
